import {FileInputDirective} from "./directive/FileInput";
import {FileUploadCroppieComponent} from "./components/file_uppload_croppie/file-upload-croppie.component";
import {CroppieWrapper} from "./directive/croppie_wrapper/CroppieWrapper";
import {ImgCropperModuleConfiguration} from "./ImageCropperModuleConfiguration";
import {CroppieOptionsService} from "./service/CroppieOptionsService";
import {CroppieOptionsServiceName, ImageUploadServiceName} from "../utils/names/serviceNames";
import {ImageService} from "./service/image.service";

ImgCropperModuleConfiguration
    .createNewModule()
    .service(ImageUploadServiceName, ImageService.instance)
    .service(CroppieOptionsServiceName, CroppieOptionsService.instance)
    .directive('fileInput', FileInputDirective)
    .component('croppie', CroppieWrapper)
    .component('croppieUpload', FileUploadCroppieComponent.instance);